<div style="padding:24px">
  <app-permission [project]="project"></app-permission>

  <app-customer-contact [project]="project"></app-customer-contact>
</div>